import { TefComs4p } from '@mfe/components/TefComs4p';
import { App } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single app consent block
//
// {app name}
// {app consent status}
//
export const singleAppConsentEdit = function render(this: TefComs4p, app: App) {
  return html`
    <one-checkbox ?checked="${app.granted}" @change=${(e : PointerEvent) => { this.toggleAppConsent(e, app); }}>
      <one-text size="lg">
          ${app.name}
      </one-text>
    </one-checkbox>
  `;
};
